import React from 'react';

const WidgetToolbar = ({ activeClientTab, setShowPopup }) => {
  return (
    <div className="flex justify-between items-center mx-4 px-2.5 py-2 rounded-md border border-secondaryLight bg-opacity-10" style={{ backgroundColor: 'color-mix(in srgb, var(--color-secondary-light) 10%, transparent)' }}>
      <div className="flex gap-2.5 items-end">
        <button
          className={`text-secondary border-none px-3 py-2 rounded font-extrabold text-sm transition-transform hover:translate-y-[-2px] active:translate-y-0 flex items-center justify-end gap-1.5 ${!activeClientTab ? 'opacity-50 cursor-not-allowed' : ''}`}
          onClick={() => setShowPopup(true)}
          disabled={!activeClientTab}
        >
          + Add Widget
        </button>
      </div>
    </div>
  );
};

export default WidgetToolbar;